module.exports = __webpack_public_path__ + "static/img/irakli.e7b65aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/groom/irakli.jpg
// module id = jox5
// module chunks = 1